
export default {
    AUTH: 'AUTH',
    GUEST: 'GUEST',
    ALL: 'ALL'
}

